import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container, Description, Title, Content, HeroLink, Links, KioskImage } from './hero.styles';
import { renderWhenNotNil } from '../../utils/rendering';
import { EntityRefData } from '../entityRefData';
import { MediaCover } from '../mediaCover';
import { linkPropType } from '../../../propTypes';

export class Hero extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    media: PropTypes.string,
    videoPoster: PropTypes.string,
    small: PropTypes.bool,
    links: PropTypes.arrayOf(linkPropType),
    kioskLogo: PropTypes.object,
  };

  renderDescription = () => <Description>{this.props.description}</Description>;

  renderLink = ({ label, url }) => (
    <HeroLink key={url} to={url}>
      {label}
    </HeroLink>
  );

  renderLinks = () => <Links>{this.props.links.map(this.renderLink)}</Links>;

  render() {
    const { title, description, media, links, videoPoster, kioskLogo } = this.props;

    return (
      <Container small={this.props.small}>
        <EntityRefData id={media}>
          {renderWhenNotNil(media => (
            <EntityRefData id={videoPoster}>
              {({ file: poster } = {}) => <MediaCover media={media} poster={poster} />}
            </EntityRefData>
          ))}
        </EntityRefData>

        <Content>
          {renderWhenNotNil(() => (
            <EntityRefData id={kioskLogo.sys.id}>
              {({ file } = {}) => <KioskImage alt={file.fileName} src={file.url} />}
            </EntityRefData>
          ))(kioskLogo)}

          <Title>{title}</Title>
          {renderWhenNotNil(this.renderDescription)(description)}
          {renderWhenNotNil(this.renderLinks)(links)}
        </Content>
      </Container>
    );
  }
}
